import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownItem, DropdownItemProps } from './Dropdown'
import {
  AdjustmentsIcon,
  ArchiveIcon,
  ArrowUpIcon,
  BanIcon,
  ClipboardCopyIcon,
  CollectionIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/react/solid'

interface NamedDropdownItemProps extends DropdownItemProps {
  permission?: boolean
  enabled?: boolean
}

export const EditDropdownItemLink: FC<NamedDropdownItemProps> = ({
  permission = true,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <DropdownItem
      disabled={!permission}
      {...props}
      label={t('dropdown.edit')}
      icon={PencilIcon}
      inAppLink
    />
  )
}

export const EditDropdownItem: FC<NamedDropdownItemProps> = ({ permission = true, ...props }) => {
  const { t } = useTranslation()

  return (
    <DropdownItem disabled={!permission} {...props} label={t('dropdown.edit')} icon={PencilIcon} />
  )
}

export const CopyDropdownItem: FC<NamedDropdownItemProps> = ({ permission, ...props }) => {
  const { t } = useTranslation()

  return (
    <DropdownItem
      disabled={!permission}
      {...props}
      label={t('dropdown.copy')}
      icon={ClipboardCopyIcon}
    />
  )
}

export const ArchiveDropdownItem: FC<NamedDropdownItemProps> = ({ permission, ...props }) => {
  const { t } = useTranslation()

  return (
    <DropdownItem
      disabled={!permission}
      {...props}
      label={t('dropdown.archive')}
      icon={ArchiveIcon}
    />
  )
}

export const RestoreDropdownItem: FC<NamedDropdownItemProps> = ({
  permission = true,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <DropdownItem
      {...props}
      label={t('dropdown.restore')}
      icon={ArrowUpIcon}
      disabled={!permission}
    />
  )
}

export const DeleteDropdownItem: FC<NamedDropdownItemProps> = ({ permission = true, ...props }) => {
  const { t } = useTranslation()

  return (
    <DropdownItem disabled={!permission} {...props} label={t('dropdown.delete')} icon={TrashIcon} />
  )
}

export const ViewSessionsDropdownItem: FC<NamedDropdownItemProps> = (props) => {
  const { t } = useTranslation()

  return <DropdownItem {...props} label={t('dropdown.view_sessions')} icon={CollectionIcon} />
}

export const CancelDropdownItem: FC<NamedDropdownItemProps> = (props) => {
  const { t } = useTranslation()

  return <DropdownItem {...props} label={t('dropdown.cancel')} icon={BanIcon} />
}

export const ToggleEnabledDropdownItem: FC<NamedDropdownItemProps & { enabled: boolean }> = ({
  enabled,
  onClick,
  permission,
}) => {
  const { t } = useTranslation()

  const label = enabled ? t('dropdown.disable_for_site') : t('dropdown.enable_for_site')

  return (
    <DropdownItem label={label} icon={AdjustmentsIcon} onClick={onClick} disabled={!permission} />
  )
}
